import { render } from "./page-recomend-term.vue?vue&type=template&id=12cda4c1&scoped=true"
import script from "./page-recomend-term.vue?vue&type=script&lang=js"
export * from "./page-recomend-term.vue?vue&type=script&lang=js"

import "./page-recomend-term.vue?vue&type=style&index=0&id=12cda4c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cda4c1"]])

export default __exports__